import InfoLabel, { InfoLabelProps } from "./InfoLabel";
import Icon, { IconType, isIcon } from "../Icon";
import { formatCurrency, Currency } from "../../utils";
import { useTexts } from "../../hooks";

type CurrencyLabelProps = InfoLabelProps & {
  currency: Currency;
  value: string | number;
  badge: string | IconType;
};

const CurrencyLabel: React.FC<CurrencyLabelProps> = (props) => {
  const { visible, direction, shape, currency, value, badge = "" } = props;
  const { common } = useTexts();

  let badgeEl: any = "";

  if (isIcon(badge)) {
    badgeEl = <Icon type={badge as IconType} size={25} />;
  } else {
    badgeEl = <div className="color text-white">{common[badge] || ""}</div>;
  }

  return (
    <InfoLabel shape={shape} direction={direction} visible={visible}>
      {badgeEl}
      <div className="color text-yellow currency">
        {formatCurrency(value, currency)}
      </div>
    </InfoLabel>
  );
};

export default CurrencyLabel;
